import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumn } from "./common.styles";
import { HXMobileButton } from "./HXButton";
export const FilterSheetBody = styled(FlexColumn) `
    gap: 0;
    width: 100%;
    padding-top: 8px;
    border-top: 0.37px solid ${colors.history_separator};
    box-sizing: border-box;
`;
export const FilterSheetSectionDivider = styled.div `
    width: 100%;
    height: 0;
    border-top: 0.37px solid ${colors.history_separator};
    margin: 12px 0;
    box-sizing: border-box;
`;
export const FilterSheetSectionHeadingRow = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin: 12px 0;
    box-sizing: border-box;
`;
export const FilterSheetSectionHeading = styled.p `
    margin: 0;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: ${fontWeights.BOLD};
    color: #55545e;
    letter-spacing: 0.24px;
    line-height: 100%;
    text-transform: uppercase;
    white-space: nowrap;
`;
export const FilterSheetSectionHeadingRule = styled.div `
    flex: 1;
    height: 0;
    border-top: 0.37px solid ${colors.history_separator};
    box-sizing: border-box;
`;
export const FilterSheetPillsGroup = styled.div `
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    padding: 0;
    width: 100%;
    box-sizing: border-box;
`;
const filterSheetPillStyles = `
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 12px 0 4px;
    border: none;
    border-radius: 100px;
    flex-shrink: 0;
    font-family: inherit;
    font-size: 13px;
    font-weight: ${fontWeights.NORMAL};
    white-space: nowrap;
    letter-spacing: -0.08px;
    line-height: 20px;
`;
export const FilterSheetPillActive = styled.button `
    ${filterSheetPillStyles}
    background-color: ${(props) => { var _a; return (_a = props.$pillBgColor) !== null && _a !== void 0 ? _a : colors.navy_main; }};
    color: ${(props) => { var _a; return (_a = props.$pillTextColor) !== null && _a !== void 0 ? _a : colors.white_main; }};
    cursor: pointer;
`;
export const FilterSheetPillInactive = styled.button `
    ${filterSheetPillStyles}
    background-color: ${(props) => { var _a; return (_a = props.$pillBgColor) !== null && _a !== void 0 ? _a : colors.navy_8; }};
    color: ${(props) => (props.$disabled ? colors.navy_30 : colors.navy_main)};
    cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
    opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`;
export const FilterSheetPillRemoveBadge = styled.span `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    flex-shrink: 0;
    box-sizing: border-box;
    color: ${(props) => { var _a; return (_a = props.$pillTextColor) !== null && _a !== void 0 ? _a : colors.white_main; }};
`;
export const FilterSheetFooter = styled.div `
    display: flex;
    gap: 8px;
    width: 100%;
    padding-top: 0;
    box-sizing: border-box;
`;
const filterSheetFooterButtonStyles = `
    flex: 1;
    min-width: 0;
    height: 56px;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.BOLD};
    text-transform: none;
    letter-spacing: -0.08px;
    border-radius: 100px;
`;
export const FilterSheetResetButton = styled(HXMobileButton).attrs({ secondary: true }) `
    && {
        ${filterSheetFooterButtonStyles}
        border-color: ${colors.navy_main};
        color: ${colors.navy_main};
    }

    &&:disabled {
        border-color: ${colors.navy_30};
        color: ${colors.navy_30};
    }
`;
export const FilterSheetContinueButton = styled(HXMobileButton) `
    && {
        ${filterSheetFooterButtonStyles}
        background-color: ${colors.navy_main};
        color: ${colors.white_main};
    }

    &&:disabled {
        background-color: ${colors.navy_30};
        color: ${colors.white_main};
    }
`;
